import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconFilter = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.9016 0.518438C14.7422 0.200625 14.4178 0 14.0625 0H0.937515C0.582203 0 0.257828 0.200625 0.0984526 0.518438C-0.0590473 0.83625 -0.0252973 1.21594 0.187515 1.5L5.62501 8.74969V14.0625C5.62501 14.5809 6.04408 15 6.56251 15H8.43752C8.95595 15 9.37502 14.5809 9.37502 14.0625V8.74969L14.8125 1.5C15.0253 1.21594 15.0591 0.83625 14.9016 0.518438Z",
		fill: "currentColor"
	})
});
export default SvgIconFilter;
